import React from 'react';
import { render } from 'react-dom';
import Loadable from 'react-loadable';
import { createBrowserHistory } from 'history';
// imported as babel 7 gives an error of rungenerator in saga
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import App from './App';
// Prefer react-microsoft-clarity when available, otherwise fall back to the
// official SDK. We also expose a small `window.clarity` wrapper so older
// helper code (which calls `window.clarity('event', name)` or
// `window.clarity('set', key, value)`) continues to work.
let _reactClarity = null;
try {
  // try the react wrapper
  // eslint-disable-next-line global-require
  const pkg = require('react-microsoft-clarity');
  _reactClarity = pkg && pkg.clarity;
  if (_reactClarity && typeof _reactClarity.init === 'function') {
    _reactClarity.init('vifm4xediw');
  }
} catch (e) {
  try {
    // fallback to legacy SDK if installed
    // eslint-disable-next-line global-require
    const Clarity = require('@microsoft/clarity');
    if (Clarity && typeof Clarity.init === 'function') {
      Clarity.init('vifm4xediw');
    }
  } catch (e2) {
    // no clarity package installed — instrumentation calls will be no-ops
  }
}

if (typeof window !== 'undefined') {
  window.__JB_CLARITY_DEBUG = true;

  const originalClarity =
    typeof window.clarity === 'function' ? window.clarity : null;

  // expose a unified window.clarity function that delegates to the react
  // wrapper when available, otherwise falls back to any existing global
  // clarity implementation.
  // Signature is compatible with existing helper usage: window.clarity('event', name)
  window.clarity = function clarityWrapper(action, ...args) {
    try {
      if (
        _reactClarity &&
        typeof _reactClarity.hasStarted === 'function' &&
        _reactClarity.hasStarted()
      ) {
        if (action === 'event') return _reactClarity.setEvent(String(args[0]));
        if (action === 'set')
          return _reactClarity.setTag(String(args[0]), String(args[1]));
      }

      if (originalClarity) {
        return originalClarity(action, ...args);
      }
    } catch (e) {
      if (window.__JB_CLARITY_DEBUG) console.warn('clarity wrapper error', e);
    }
    return undefined;
  };

  try {
    // small async check to allow SDK to attach
    setTimeout(
      () =>
        console.log(
          'Clarity wrapper ready:',
          typeof window.clarity === 'function',
        ),
      50,
    );
  } catch (e) {
    // ignore
  }
}

const history = createBrowserHistory();

Loadable.preloadReady().then(() => {
  const container = document.getElementById('root');
  const bootstrap = render;
  const props = {
    history,
  };

  bootstrap(<App {...props} />, container);
});
